import { LocationVarKey } from "@swivl-mono/types";


import { IF_ANY, IS_EQUAL, IS_NOT_EQUAL } from "../../../Components/Worksheets/Types/Worksheet.Interface";

import {
  Indent,
  SwitchRow,
  TextAreaRow,
  TextRow,
  DropdownRow,
  InputRow,
  SectionHeader,
  PageHeader,
  Section
} from "../../../Components/Worksheets/WorksheetComponent/WorksheetComponents";
import { usePropertiesGetLocationIds } from "../../../Hooks/usePropertiesGetLocationIds";

export default function WorksheetView() {
  const page = usePropertiesGetLocationIds();
  return (
    <>
      <PageHeader {...page}>General Settings</PageHeader>
      <h4>Welcome Message</h4>
      <TextAreaRow {...page} marginTop label="" keyName={LocationVarKey.VoiceWelcomeMessage} />
      <h4>Anything Else Message</h4>
      <TextAreaRow {...page} marginTop label=" " keyName={LocationVarKey.VoiceAnythingElseMessage} />
      <h4>Hangup Message</h4>
      <TextAreaRow {...page} marginTop label=" " keyName={LocationVarKey.VoiceHangupMessage} />
      <SectionHeader {...page}> Escalation Settings </SectionHeader>
      <DropdownRow
        {...page}
        label="Send sales escalations to"
        marginTop
        keyName={LocationVarKey.VoiceSalesEscalateTo}
        options={[
          { label: "swivl Conversations", value: "swivl" },
          { label: "External Phone Number", value: "phone" },
        ]}
      />
      <InputRow {...page} hideIf={IS_EQUAL(LocationVarKey.VoiceSalesEscalateTo, "swivl")} keyName={LocationVarKey.VoiceSalesPhoneNumber} label="Sales Escalation Phone Number" />

      <DropdownRow
        {...page}
        label="Send customer service escalations to"
        marginTop
        keyName={LocationVarKey.VoiceServiceEscalateTo}
        options={[
          { label: "swivl Conversations", value: "swivl" },
          { label: "External Phone Number", value: "phone" },
        ]}
      />
      <InputRow {...page} hideIf={IS_EQUAL(LocationVarKey.VoiceServiceEscalateTo, "swivl")} keyName={LocationVarKey.VoiceServicePhoneNumber} label="Customer Service Escalation Phone Number" />
      <h4>Permission to Escalate Message</h4>
      <TextAreaRow {...page} marginTop label=" " keyName={LocationVarKey.VoicePermissionToEscalateMessage} />
      <h4>Pre-Escalate Message</h4>
      <TextAreaRow {...page} marginTop label=" " keyName={LocationVarKey.VoicePreEscalateMessage} />
      <TextRow {...page}>
        {" "}
        Be sure to review your<a href="https://v3.swivl.studio/properties/page/cortex/sequences/sms-settings"> SMS Disclaimer </a> message. Use this
        to introduce callers to your company and provide opt-out instructions.
      </TextRow>

      <SectionHeader {...page}> Automations </SectionHeader>
      <br></br>
      <SwitchRow {...page} keyName={LocationVarKey.VoiceHasShowInventory} label="Rent a Unit" />
      <SwitchRow {...page} keyName={LocationVarKey.VoiceHasAccountBalance} label="Account Balance" />
      <Indent {...page}>
        <SwitchRow
          {...page}
          keyName={LocationVarKey.VoiceHasAccountBalanceIntegration}
          label="FMS Integration"
          hideIf={IS_NOT_EQUAL(LocationVarKey.VoiceHasAccountBalance, "1")}
        />
      </Indent>
      <SwitchRow {...page} keyName={LocationVarKey.VoiceHasAccountNumber} label="Account Number" hideIf={IS_NOT_EQUAL(LocationVarKey.WhichFMS,"StorEdge")} />
      <Indent {...page}>
        <SwitchRow
          {...page}
          keyName={LocationVarKey.VoiceHasAccountNumberIntegration}
          label="FMS Integration"
          hideIf={IF_ANY([IS_NOT_EQUAL(LocationVarKey.VoiceHasAccountNumber, "1"),IS_NOT_EQUAL(LocationVarKey.WhichFMS,"StorEdge")])}
        />
      </Indent>
      <SwitchRow {...page} keyName={LocationVarKey.VoiceHasGateCode} label="Gate Code" />
      <Indent {...page}>
        <SwitchRow
          {...page}
          keyName={LocationVarKey.VoiceHasGateCodeIntegration}
          label="FMS Integration"
          hideIf={IS_NOT_EQUAL(LocationVarKey.VoiceHasGateCode, "1")}
        />
      </Indent>
      <SwitchRow {...page} keyName={LocationVarKey.VoiceHasPayBill} label="Pay Bill" />
      <SwitchRow {...page} keyName={LocationVarKey.VoiceHasLoginIssues} label="Login Issues" />
      <SwitchRow {...page} keyName={LocationVarKey.VoiceHasCancel} label="Cancel" />
      <SwitchRow {...page} keyName={LocationVarKey.VoiceHasEditAccountInfo} label="Update Account Info" />
      <SwitchRow {...page} keyName={LocationVarKey.VoiceHasGetLease} label="Get Lease" />
      <SwitchRow {...page} keyName={LocationVarKey.VoiceHasPaymentHistory} label="Payment History" />
      <SwitchRow {...page} keyName={LocationVarKey.VoiceHasAutopay} label="Autopay" />
      <SwitchRow {...page} keyName={LocationVarKey.VoiceHasManageInsurance} label="Manage Insurance" />
    </>
  );
}
